<template>
  <v-app :class="{ watermark: isStaging }">
    <v-toolbar
      app
      :clipped-left="clipped"
      color="primary"
      :class="{ watermarksm: isStaging }"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <div>
        <img
          src="@/assets/images/vonexLogo.png"
          alt="smallLogo"
          height="64px"
          style="padding: 9px;"
        />
      </div>

      <v-spacer></v-spacer>
      <v-card color="primary" class="d-inline ma-0 pa-0">
        <v-card-text class="text-lg-left ma-0 pa-0">
          <v-btn v-if="!isAuthenticated" small to="/login">Login</v-btn>
          <div v-if="isAuthenticated ">
            <span
              class="text-muted font-weight-light px-2"
              style="color: #fff !important;"
            >
              {{ dealer.dealerEmail || userProfile.name }}
            </span>
            <v-btn
              small
              color="danger"
              v-if="isAuthenticated"
              v-on:click="logout()"
            >
              Logout
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-toolbar>

    <v-navigation-drawer
      :clipped="clipped"
      v-model="drawer"
      :disable-resize-watcher="false"
      app
      floating
      persistent
      mobile-break-point="991"
      width="260"
    >
      <v-toolbar flat color="secondary">
        <v-list>
          <v-list-tile @click="navigate('/list-commissions')">
            <v-list-tile-title class="title">Start</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list light>
        <v-list-group
          v-for="(item, index) in items.filter((x) => featureFlag(x))"
          :key="index"
          @click="navigate(item.route)"
          :prepend-icon="item.icon"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-for="(subItem, i) in item.subMenu"
            :key="i"
            @click="navigate(subItem.route)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <router-view
        :isAuthenticated="isAuthenticated"
        :userProfile="userProfile"
      />
      <message-alert></message-alert>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span>&copy; 2018 Copyright: vonex.com.au</span>
    </v-footer>
    <v-dialog
      v-model="mfadialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <mfa-dialog @closeDialog="closeMFADialog"></mfa-dialog>
    </v-dialog>
  </v-app>
</template>

<script>
import Vue from "vue";
import AppTitle from "@/components/app-title.vue";
import MessageAlert from "@/components/MessageAlert";
import MfaDialog from "@/components/EnrollMFADialog.vue";

import { createNamespacedHelpers } from "vuex";
import { createHelpers } from "vuex-map-fields";
import AppAlert from "@/components/app-alert";
import items from "@/components/menuItems";
import moment from "moment";
import VeeValidate from "vee-validate";
import DatePicker from "vue2-datepicker";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

Vue.component("date-picker", DatePicker);

Vue.use(VuejsDialog);
Vue.use(VeeValidate);
Vue.component("app-alert", AppAlert);
Vue.component("mfa-dialog", MfaDialog);
const PhoneNumber = require("awesome-phonenumber");
VeeValidate.Validator.extend("phonenumber", {
  // Custom validation message
  getMessage: (field) => `The ${field} is not a valid phone number.`,
  // Custom validation rule
  validate: (value) =>
    new Promise((resolve) => {
      const pn = new PhoneNumber(value, "AU");

      resolve({
        valid: pn.isValid() || pn.isMobile(),
      });
    }),
});

VeeValidate.Validator.extend("mobilenumber", {
  // Custom validation message
  getMessage: (field) => `The ${field} is not a valid mobile.`,
  // Custom validation rule
  validate: (value) =>
    new Promise((resolve) => {
      var pn = new PhoneNumber(value, "AU");
      resolve({
        valid: pn.isMobile(),
      });
    }),
});

VeeValidate.Validator.extend("duplicate-employee", {
  // Custom validation message
  getMessage: (field) =>
    `This ${field} is already associated to an existing emploee`,
  // Custom validation rule
  validate: (value) =>
    new Promise((resolve) => {
      this.GetAllEmployeesForDealer().then((x) => {});
      // payload.allEmployees.some(x => x.email === value)

      // var pn = new PhoneNumber(value, "AU");
      resolve({
        valid: false,
      });
    }),
});

VeeValidate.Validator.extend("hrs", {
  getMessage: (field) =>
    `Please enter the ${field} value in 24 hour time format`,
  validate: (value) => /^([01]?[0-9]|2[0-3]):[0-5][0-9]?$/.test(value),
});

VeeValidate.Validator.extend("date-range", {
  getMessage: (field) =>
    `Please enter both all in ${field} are set to DD/MM format and are separated by a comma.`,
  validate: (value) =>
    /^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[,]?)*$/g.test(value),
});

VeeValidate.Validator.extend("email-multiple", {
  getMessage: (field) =>
    `Addresses in ${field} must be in the correct email format and separated by semi-colons (;)`,
  validate: (value) =>
    /^([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?[;]?)*$/g.test(
      value
    ),
});

VeeValidate.Validator.extend("hrs-range", {
  getMessage: (field) =>
    `Please enter all intervals in ${field} are in 24 hour time format, have a start and end time and if more than one, separated by a space.`,
  validate: (value) =>
    /^(([01]?[0-9]|2[0-3]):[0-5][0-9]-([01]?[0-9]|2[0-3]):[0-5][0-9][\s]?)*$/g.test(
      value
    ),
});

VeeValidate.Validator.extend("duplicate-email", {
  getMessage: (field) => `This ${field} is required`,
  validate: (value) =>
    /^([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?[;]?)*$/g.test(
      value
    ),
});

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("formatTime", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY HH:mm");
  }
});
Vue.filter("orderStatus", function(value) {
  switch (value) {
    case 0:
      return "New";
    case 1:
      return "In Progress";
    case 2:
      return "Signed";
    case 3:
      return "Completed";
    case 4:
      return "Cancelled";
    case 5:
      return "Rejected";
    default:
      return "Unknown";
  }
});

Vue.filter("currency", function formatMoney(n) {
  var c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(2)))),
    j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
});
const {
  mapGetters: mapAuthGetters,
  mapActions: mapAuthActions,
} = createNamespacedHelpers(`auth`);
const { mapGetters: mapDealerGetters } = createNamespacedHelpers(`dealer`);
const { mapState: mapDealerState } = createNamespacedHelpers(`dealer`);

export const { mapFields: mapAuthFields } = createHelpers({
  getterType: `auth/getField`,
  mutationType: `auth/updateField`,
});

Vue.component("app-title", AppTitle);
Vue.component("message-alert", MessageAlert);
export default {
  name: "DealerPortal",
  data() {
    return {
      clipped: true,
      drawer: null,
      fixed: false,
      items: items.items,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Sign On Glass Partner Administration",
      responsive: false,
      responsiveInput: false,
      mfadialog: false,
    };
  },
  methods: {
    ...mapAuthActions(["login", "logout"]),
    navigate: function(route) {
      this.$router.push(route);
    },
    featureFlag(val) {
      if (!val) return false;
      if (!this.dealer && !this.dealer.dealerEmail) return false;
      try {
        let returnValue = false;
        switch (val.feature) {
          case "default":
            returnValue =
              this.dealer.authLevel !== "Employee"
                ? true
                : val.security == this.dealer.authGroup;
            break;
          case "Vonex":
            if (
              this.dealer.dealerEmail.includes("vonex.com.au") ||
              this.dealer.dealerEmail.includes("alsconsulting.com.au")
            )
              returnValue = true;
            break;
          case "nampt":
            returnValue = this.isBetaTester;
            break;
        }
        return returnValue;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    openMFADialog() {
      this.mfadialog = true;
    },
    closeMFADialog() {
      this.mfadialog = false;
    },
  },
  computed: {
    ...mapAuthFields(["token", "userProfile"]),
    ...mapDealerState(["dealer"]),
    ...mapAuthGetters(["isAuthenticated"]),
    ...mapDealerGetters(["isBetaTester"]),
    isStaging() {
      return (
        process.env.NODE_ENV == "staging" ||
        process.env.NODE_ENV == "development"
      );
    },
  },
};
</script>
<style>
@import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";

.dg-container {
  font-family: Roboto, sans-serif;
}

.dg-btn-loader .dg-circle {
  background-color: green;
}
.watermark {
  background: url("https://vonex.com.au/vonex/projects/watermark-blck.png")
    repeat !important;
}
.watermarksm {
  background: url("https://vonex.com.au/vonex/projects/watermark-small.png")
    repeat !important;
}
</style>
